import { TimeSlotGrid } from '../../TimeSlotGrid'
import SidewaysDateSelector from '../../SidewaysDateSelector'

const CalendarView = ({
  bookingDate,
  selectedDate,
  setSelectedDate,
  onSlotSelect,
  currentEventTypeObject,
  mentorProfile,
  currentBookedEventId,
  clinicLocation = null, // Clinic location for timezone
  bookedSlots = [], // Booked slots to disable overlapping slots
  bookedSlotsLoading = false, // Loading state for booked slots
  onDatesLoaded = null, // Callback for lazy loading slots
}) => {
  return (
    <>
      <div style={{ marginBottom: '8px' }}>
        <SidewaysDateSelector
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          minDate={bookingDate}
          maxDate={bookingDate.add(12, 'month')}
          daysToShow={365}
          bookingDate={bookingDate}
          onDatesLoaded={onDatesLoaded}
          showHeader={false}
        />
      </div>
      <TimeSlotGrid
        minDate={bookingDate}
        maxDate={bookingDate.add(1, 'month')}
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        onSlotSelect={onSlotSelect}
        eventDuration={currentEventTypeObject?.durationInMins || 30}
        mentorProfile={mentorProfile}
        currentBookedEventId={currentBookedEventId}
        currentEventTypeObject={currentEventTypeObject}
        clinicLocation={clinicLocation}
        bookedSlots={bookedSlots}
        bookedSlotsLoading={bookedSlotsLoading}
      />
    </>
  )
}

export default CalendarView
